/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum FlagsIOS {
  OPAQUE = 0,
  MASKS_TO_LAYER = 1,
  DOUBLE_SIDED = 2,
  GEOMETRY_FLIPPED = 3,
  BLOCKED = 4,
  USER_INTERACTION_ENABLED = 5,
  SCRUBBED = 6,
  WEBVIEW = 7,
  DARK_MODE = 8,
  MASKED = 9,
  FOCUSED = 10,
}
